<template>
	<div tabindex="0" class="hide-outline">
		<main v-if="loaded" class="main-view no-top-panel">
			<SummaryComponent
				:infos="infos"
				:checklists="checklists"
				@back="toDashboard"
				@print="toPrint"
			/>
		</main>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import SummaryComponent from './components/Summary';

export default {
	components: {
		SummaryComponent
	},
	data: () => ({
		historyDone: false,
		questionsDone: false,
		infosDone: false
	}),
	computed: {
		...mapGetters('appStore', ['isMobile']),
		...mapGetters('roundStore', ['round']),
		...mapGetters('roundHistoryStore', ['roundHistory']),
		...mapGetters('roundHistoryInfoStore', ['roundHistoryInfos']),
		...mapState('roundHistoryInfoStore', {
			infoParams: 'searchParams'
		}),
		...mapGetters('roundHistoryQuestionStore', ['roundHistoryQuestionLists']),
		...mapState('roundHistoryQuestionStore', {
			questionParams: 'searchParams'
		}),
		...mapState('fileStore', ['file']),
		mobile() {
			return this.isMobile ? { display: 'block' } : '';
		},
		loaded() {
			return this.historyDone && this.questionsDone && this.infosDone;
		},
		infos() {
			let list = [];

			if (this.roundHistoryInfos) {
				list = this.roundHistoryInfos;
			}

			return list;
		},
		checklists() {
			let list = [];

			if (this.roundHistoryQuestionLists) {
				list = this.roundHistoryQuestionLists;
			}

			return list;
		}
	},
	methods: {
		...mapMutations('appStore', ['SET_COLLAPSED']),
		...mapActions('appStore', ['setPrintMode']),
		...mapActions('roundStore', ['setRound']),
		...mapActions('roundHistoryStore', ['getRoundHistory']),
		...mapActions('roundHistoryQuestionStore', [
			'getRoundHistoryQuestionLists'
		]),
		...mapActions('roundHistoryInfoStore', ['getRoundHistoryInfos']),
		...mapActions('flawStore', ['createFlaw', 'updateFlaw']),
		...mapActions('roundHistoryStore', ['updateRoundHistory']),
		...mapActions('fileStore', ['getFile']),
		async asyncForEach(array, callback) {
			for (let index = 0; index < array.length; index++) {
				await callback(array[index], index, array);
			}
		},
		toDashboard() {
			this.$router.push({
				name: 'Dashboard'
			});
		},
		toPrint() {
  const routeData = this.$router.resolve({
    name: 'FinishedRoundView', // or path: '/FinishedRoundView'
    params: {
      roundId: this.$route.params.roundId,
      print: true
    }
  });
  window.open(routeData.href, '_blank');
}

	},
	async created() {
		if (!this.isMobile) this.SET_COLLAPSED(true);

		const roundId = this.$route.params.roundId;
		this.questionParams.pageSize = 0;
		this.infoParams.pageSize = 0;
		this.questionParams.roundHistoryId = roundId;
		this.infoParams.roundHistoryId = roundId;

		await this.getRoundHistory(roundId).then(() => {
			this.setRound(this.roundHistory);
			this.historyDone = true;
		});
		await this.getRoundHistoryInfos().then(() => {
			this.infosDone = true;
		});
		await this.getRoundHistoryQuestionLists().then(() => {
			this.questionsDone = true;
		});

		if (this.$route.params.print) {
			this.setPrintMode(true);
			setTimeout(() => {
				window.print();
			}, 1000);
		}
	},
	beforeDestroy() {
		this.SET_COLLAPSED(false);
		this.setPrintMode(false);
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";

.top-box {
  background: $lightest-grey;
  padding: 10px 5px 10px 5px;
  display: block;
  border-radius: 2px;
  margin-bottom: 10px;
  .row {
    display: flex;
  }
  .field {
    &.name {
      flex: 1;
    }
    &.description {
      flex: 2;
    }
    margin-left: 10px;
    margin-right: 10px;
    .label {
      font-size: 12px;
    }
  }
  .textarea,
  .input {
    background: white;
    border-radius: 2px;
  }
  .buttons {
    margin: 0;
    margin-top: 19px;
    margin-left: 10px;
    .button {
      border-radius: 2px;
      width: 110px;
    }
  }
}
.tabs.is-boxed {
  margin-bottom: 0;
}

@media print {
  #noPrint,
  #noPrint * {
    display: none;
  }
}
</style>
